import API from '../';
import { HTTP_METHODS } from '../helpers/methods-helpers';

class SearchAPI extends API {
	getSearch(text) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}?pClave=${text}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
	getSearchByFilters(
		text,
		organ,
		session,
		area,
		fecha,
		status,
		pagination,
		currentPage
	) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}?pClave=${text}&organo=${organ}&sesion=${session}
				&areaAsignacion=${area}&fechaCumplimiento=${fecha}&estatus=${status}&registrosPorPagina=${pagination}&numeroDePagina=${currentPage}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
}

export const searchAPI = new SearchAPI('/busqueda-avanzada');
